import classnames from 'classnames';
import { Spinner } from 'reactstrap';
import useButtonLoading from './useButtonLoading';

export type ButtonLoadingProps = {
  id?: string;
  className?: string;
  isFilled?: boolean;
  title?: string;
  shouldDisplayLoadingCursor?: boolean;
};

const ButtonLoading = ({
  id,
  className,
  isFilled = false,
  title,
  shouldDisplayLoadingCursor = false,
}: ButtonLoadingProps) => {
  useButtonLoading({ shouldDisplayLoadingCursor });

  return (
    <div className="button-loading-spinner flex" id={id}>
      <Spinner className={classnames(isFilled ? '--filled' : '', className)}>
        {/* eslint-disable-next-line react/jsx-curly-brace-presence -- must be a literal empty string, not omitted: reactstrap's Spinner defaultProps falls back to children="Loading..." when children is undefined */}
        {''}
      </Spinner>
      {!!title && <span>{title}</span>}
    </div>
  );
};

export default ButtonLoading;
